export interface IUserSurvey {
  id: number;
  response: Array<unknown>;
  user_study_survey_id: number;
  language_region_code?: string;
}
